export default "<link href=\"https://cdn.jsdelivr.net/npm/font-awesome@4.x/css/font-awesome.min.css\" rel=\"stylesheet\">\n";